import { EntrataConnectForm } from './EntrataConnectForm'
import type { VendorConnectorProps } from './types'

export function EntrataConnector({ onConnected }: VendorConnectorProps) {
  return <EntrataConnectForm onConnected={() => onConnected?.()} />
}
